import queryString from 'query-string';
import React from 'react';
import cookie from 'react-cookies';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { compose, lifecycle, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../constants';
import { Loading } from './';

/**
 * Responsible handling a redirect back to our site after an auth0 redirect
 */

const Referral = () => (
  <Loading />
);

function saveReferralCode({ cookies, referralCode, goTo }) {
  cookie.save('referralCode', referralCode, { path: '/' });
  goTo({ pathname: routes.onboarding.choosePlan });
}

const mapStateToProps = (state) => ({
  auth0Config: state.configuration.auth0Config
});

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch)
});

export default compose(

  connect(mapStateToProps, mapDispatchToProps),
  withProps(({
    location: {
      search
    }
  }) => ({
    referralCode: queryString.parse(search).code
  })),
  lifecycle({
    componentDidMount() {
      saveReferralCode(this.props)
    },
    componentWillReceiveProps(nextProps) {
      saveReferralCode(nextProps)
    }
  }),
)(Referral);



// WEBPACK FOOTER //
// ./src/containers/pages/referral.js